import { ca } from '@cian/analytics';
import { EPageBlock } from '../../../types/analytics';

import { IPage } from '../../../types/redux';

interface ITrackPromoShowParams {
  page: IPage;
  providerIds: number[];
  providerPromoIds: number[];
}

export const trackPromoShow = ({ page, providerIds, providerPromoIds }: ITrackPromoShowParams) => {
  ca('eventSite', {
    action: 'Show_sopr',
    category: 'Promo',
    name: 'oldevent',
    label: 'low_mortgage_rates',
    page: {
      ...page,
      extra: {
        block: EPageBlock.LowMortgageRates,
        builder_id: providerIds,
        Promo_id: providerPromoIds,
      },
    },
  });
};
